import type { RouteRecordRaw } from 'vue-router'

const externalServicesRoutes: RouteRecordRaw[] = [
  {
    path: '/external-services',
    name: 'external-services.index',
    component: () => {
      return import('@/modules/services/views/ExternalServicesIndex.vue')
    },
    meta: {
      pageTitle: 'External services',
      breadcrumbs: ['External services']
    }
  },
  {
    path: '/external-services/create',
    name: 'external-services.create',
    component: () => {
      return import('@/modules/services/views/ExternalServicesEdit.vue')
    },
    meta: {
      pageTitle: 'External services',
      breadcrumbs: ['External services']
    }
  },
  {
    path: '/external-services/:id/edit',
    name: 'external-services.edit',
    component: () => import('@/modules/services/views/ExternalServicesEdit.vue'),
    meta: {
      pageTitle: 'External services',
      breadcrumbs: ['External services']
    }
  }
]

export default externalServicesRoutes
